import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { DebounceClickDirective } from './directives/debounce-click.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { CommonComponentModule } from './features/common/common.module';
import { LayoutModule } from './features/layout/layout.module';
import { OutboundModule } from './features/outbound/outbound.module';
import { WorkListModule } from './features/worklist/worklist.module';
import { BytesPipe } from './pipes/bytes.pipe';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { EnumLabelPipe } from './pipes/enum-label.pipe';
import { ExcludeByPipe } from './pipes/exclude-by.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
  declarations: [
    ClickOutsideDirective,
    DebounceClickDirective,
    TooltipDirective,
    TruncatePipe,
    SafeHtmlPipe,
    DateFormatPipe,
    FilterPipe,
    BytesPipe,
    ExcludeByPipe,
  ],
  imports: [
    CommonModule,
    WorkListModule,
    LayoutModule,
    OutboundModule,
    FormsModule,
    EnumLabelPipe,
    CommonComponentModule,
    MatTooltipModule,
    NgxPermissionsModule.forChild(),
  ],
  exports: [
    WorkListModule,
    LayoutModule,
    OutboundModule,
    CommonComponentModule,
    MatTooltipModule,
    EnumLabelPipe,
    ExcludeByPipe,
  ],
})
export class SharedModule {}
